"use client";

import React, { useEffect } from 'react';
/* import Script from 'next/script'; */

const ContactUs = () => {
  useEffect(() => {
    const inputs = document.querySelectorAll('.input-text');

    inputs.forEach(input => {
      input.addEventListener('blur', () => {
        if (input.value !== '') {
          input.classList.add('not-empty');
        } else {
          input.classList.remove('not-empty');
        }
      });
    });

  /*   // Error message for tooltips
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    }); */

    // Google Sheets submission
    const scriptURL =
      'https://script.google.com/macros/s/AKfycbzwBxMK2TAsxJ1DGgAc__k-0c2FG9y8Kl6WAOXRlH5ySYU1z3HkJ6JQGzCU67r6cuCk9Q/exec';
    const form = document.forms['submit-to-google-sheet'];

    form.addEventListener('submit', e => {
      e.preventDefault();

      const submitBtn = document.getElementById('submit');
      submitBtn.disabled = true; // disable the submit button
      submitBtn.classList.add('submitting');

      fetch(scriptURL, { method: 'POST', body: new FormData(form) })
        .then(() => {
          const msg = document.getElementById('msg');
          msg.style.display = 'block';
          msg.innerHTML = 'Your request submitted successfully!';
          setTimeout(function () {
            msg.style.display = 'none';
            window.location.reload();
          }, 3000);
          form.reset();

          // enable the submit button after the form submission is complete
          submitBtn.disabled = false;
          submitBtn.classList.remove('submitting');
        })
        .catch(error => console.error('Error!', error.message));
    });
  }, []);

  return (
    <>
      {/* Contact Us Section */}
    <section className="contact-us" data-scroll-index="0">
          <h1 className="title">Contact Us</h1>
          <form name="submit-to-google-sheet">
          <div className="container">
            <div className="contact-form row">
                  <div className="form-field col-lg-6">
                    <input id="name" name="Name" className="input-text" type="text" pattern="[A-Za-z ]+" required title="Pls. provide a valid customer name using only letters and spaces. Thank you!"/>
                    <label htmlFor="name" className="label">name</label>
                  </div>
                  <div className="form-field col-lg-6">
                    <input id="email" name="E-Mail" className="input-text" type="email" required/>
                    <label htmlFor="email" className="label">email</label>
                  </div>
                  <div className="form-field col-lg-6">
                    <input id="country" name="Country" className="input-text" type="text" pattern="[A-Za-z ]+" required title="Pls. provide a valid country name using only letters and spaces. Thank you!"/>
                    <label htmlFor="country" className="label">country name</label>
                  </div>
                  <div className="form-field col-lg-6">
                    <input id="phone" name="Ph.Number" className="input-text" type="tel" pattern="\+?\d{1,3}[-.\s]?\d{3,4}[-.\s]?\d{4}" required title="Pls. provide a valid phone number to contact you. Thank you!"/>
                    <label htmlFor="phone" className="label">contact number</label>
                  </div>
                  <div className="form-field col-lg-12">
                    <div className="input-data textarea">
                      <textarea rows="8" name="Message" style={{ marginTop: "50px" }} required></textarea>
                      <label htmlFor="">Message</label>
                   </div>
                  </div>

                  <div className="form-field col-lg-12">
                    <input className="submit-btn" name="submit" id="submit" type="submit" value="submit"/>
                  </div>
                  <span id="msg"></span>
            </div>
          </div>
        </form>
        </section>
    </>
  );
};

export default ContactUs;